import React from 'react';

import { images } from '../../constants';
import './Header.css';
import { SubHeading } from '../../components';
import {Earth} from './earth';
import { data } from '../../constants';

const Header = () => (
  <div className='app__header app__wrapper section__padding' id='home'>
    <div className='app__wrapper_info'>
      <SubHeading title="Hello, I am" />
      <h1 className='app__header-h1'>Sharad Tembhurne</h1>
      <p className='p__opensans' style={{ margin: '2rem 0', fontSize: '1.35rem'}}>
        Software Engineer <br />
        Based in New York <br />
      </p>

      <a href={data.resume} target="_blank" rel="noopener noreferrer"><button type="button" class="custom__button">Download Resume</button></a>
    </div>

    <div className='app__wrapper_img'>
      <Earth />
    </div>

  </div>
);

export default Header;
